import axios from "axios";
import React, { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";
import { translate } from "../../translations";

function NewService() {
  const project = localStorage.getItem("currentProjectID");
  const [error, setError] = useState(false);
  const [payload, setPayload] = useState({ project });
  const [activatedFields, setActivatedFields] = useState([]);
  const token = localStorage.getItem("token");
  const [dropdownOptions, setDropdownOptions] = useState([]);

  const { userData } = useContext(UserDataContext);
  const [fieldData, setFieldData] = useState({
    activatedFields: [],
  });
  const history = useHistory();

  async function getData() {
    const activatedFields = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/editServices/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    setFieldData({
      activatedFields: activatedFields.data["0"].value.activatedFields,
    });
  }

  async function getDropdownOptions() {
    const userRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/dropdownOptions/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setDropdownOptions(userRes.data);
  }

  async function register(e) {
    e.preventDefault();

    try {
      console.log(payload);
      await axios.post(`${process.env.REACT_APP_BACKEND}/services/`, payload, {
        headers: {
          jwttoken: token,
        },
      });
      history.push("/services/");
    } catch (err) {
      setError(true);
      console.error(err);
    }
  }

  useEffect(() => {
    getData();
    getDropdownOptions();
  }, [userData]);

  return (
    <>
      <div className="bg-white  overflow-hidden sm:rounded-lg flex justify-center">
        <div className="px-4 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <div className="flex flex-col grow">
            <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
              <div className="px-4 py-3 bg-gray-50  sm:px-6">
                {translate("Leistung_hinzufuegen")}
              </div>
              <form onSubmit={register}>
                <div className="shadow overflow-hidden sm:rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6">
                    <div className="grid grid-cols-6 gap-6">
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("werk_standort") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("werk_standort")}
                            </label>
                            <select
                              required="true"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  werk_standort: e.target.value,
                                })
                              }
                              className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                              <option value=""></option>
                              {dropdownOptions &&
                                dropdownOptions
                                  .filter((dropdownOption) => {
                                    return (
                                      dropdownOption.field === "Werk/Standort"
                                    );
                                  })
                                  .map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("fachbereich") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("fachbereich")}
                            </label>
                            <select
                              required="true"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  fachbereich: e.target.value,
                                })
                              }
                              className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                              <option value=""></option>
                              {dropdownOptions &&
                                dropdownOptions
                                  .filter((dropdownOption) => {
                                    return (
                                      dropdownOption.field === "Fachbereich"
                                    );
                                  })
                                  .map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("abteilung") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("abteilung")}
                            </label>
                            <select
                              required="true"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  abteilung: e.target.value,
                                })
                              }
                              className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                              <option value=""></option>
                              {dropdownOptions &&
                                dropdownOptions
                                  .filter((dropdownOption) => {
                                    return dropdownOption.field === "Abteilung";
                                  })
                                  .map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("gebaeude") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("gebaeude")}
                            </label>
                            <select
                              required="true"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  gebaeude: e.target.value,
                                })
                              }
                              className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                              <option value=""></option>
                              {dropdownOptions &&
                                dropdownOptions
                                  .filter((dropdownOption) => {
                                    return dropdownOption.field === "Gebäude";
                                  })
                                  .map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("anlage") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("anlage")}
                            </label>
                            <select
                              required="true"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  anlage: e.target.value,
                                })
                              }
                              className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                              <option value=""></option>
                              {dropdownOptions &&
                                dropdownOptions
                                  .filter((dropdownOption) => {
                                    return dropdownOption.field === "Anlage";
                                  })
                                  .map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("etage") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("etage")}
                            </label>
                            <select
                              required="true"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  etage: e.target.value,
                                })
                              }
                              className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                              <option value=""></option>
                              {dropdownOptions &&
                                dropdownOptions
                                  .filter((dropdownOption) => {
                                    return dropdownOption.field === "Etage";
                                  })
                                  .map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("kostenstelle") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("kostenstelle")}
                            </label>
                            <select
                              required="true"
                              id="owner"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  kostenstelle: e.target.value,
                                })
                              }
                              className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                              <option value=""></option>
                              {dropdownOptions &&
                                dropdownOptions
                                  .filter((dropdownOption) => {
                                    return (
                                      dropdownOption.field === "Kostenstelle"
                                    );
                                  })
                                  .map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("pos_nr") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("pos_nr")}
                            </label>
                            <input
                              required
                              type="text"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  pos_nr: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("pos_name") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("pos_name")}
                            </label>
                            <input
                              required
                              type="text"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  pos_name: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes(
                          "leistungsbeschreibung_lang"
                        ) && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("leistungsbeschreibung_lang")}
                            </label>
                            <textarea
                              required
                              rows="3"
                              type="textarea"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  leistungsbeschreibung_lang: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes(
                          "leistungsbeschreibung_kurz"
                        ) && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("leistungsbeschreibung_kurz")}
                            </label>
                            <input
                              required
                              type="text"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  leistungsbeschreibung_kurz: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("menge") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("menge")}
                            </label>
                            <input
                              required
                              type="number"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  menge: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("mengeneinheit") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("mengeneinheit")}
                            </label>
                            <select
                              required="true"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  mengeneinheit: e.target.value,
                                })
                              }
                              className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                              <option value=""></option>
                              {dropdownOptions &&
                                dropdownOptions
                                  .filter((dropdownOption) => {
                                    return (
                                      dropdownOption.field === "Mengeneinheit"
                                    );
                                  })
                                  .map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("anzahl") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("anzahl")}
                            </label>
                            <input
                              required
                              type="number"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  anzahl: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("preis_1") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("preis_1")}
                            </label>
                            <input
                              required
                              type="number"
                              step="0.01"
                              min="0"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  preis_1: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("preis_2") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("preis_2")}
                            </label>
                            <input
                              required
                              type="number"
                              step="0.01"
                              min="0"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  preis_2: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("preis_3") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("preis_3")}
                            </label>
                            <input
                              required
                              type="number"
                              step="0.01"
                              min="0"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  preis_3: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                      {fieldData &&
                        fieldData.activatedFields &&
                        fieldData.activatedFields.includes("preis_4") && (
                          <div className="col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                              {translate("preis_4")}
                            </label>
                            <input
                              required
                              type="number"
                              step="0.01"
                              min="0"
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  preis_4: e.target.value,
                                })
                              }
                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                            />
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Speichern
                    </button>
                    {error && (
                      <div
                        className="flex rounded-md items-center bg-red-500 text-white text-sm font-bold px-4 py-3 my-5"
                        role="alert"
                      >
                        <svg
                          className="fill-current w-6 h-6 mr-3"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                        </svg>
                        <p>{translate("error_api")}</p>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewService;
